/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Divider, Empty, Form, Input } from 'antd';

function ExternalApisSettings({ fieldsPermissions }) {
  const hasBitrixPermissions = fieldsPermissions?.BitrixWebhookUrl.access !== 0;
  const hasCnpjPermissions =
    fieldsPermissions?.CnpjApiUrl.access !== 0 || fieldsPermissions?.CnpjApiToken.access !== 0;
  const hasHolidayPermissions =
    fieldsPermissions?.HolidayApiUrl.access !== 0 ||
    fieldsPermissions?.HolidayApiToken.access !== 0;
  const hasQueuePermissions =
    fieldsPermissions?.Bitrix24QueueMiddlewareEndpoint.access !== 0 ||
    fieldsPermissions?.Bitrix24QueueMiddlewareAuthToken.access !== 0;

  const hasOmiePermissions =
    fieldsPermissions?.OmieApiUrl.access !== 0 ||
    fieldsPermissions?.OmieApiKey.access !== 0 ||
    fieldsPermissions?.OmieApiSecret.access !== 0;

  const hasAnyPermissions =
    hasBitrixPermissions ||
    hasCnpjPermissions ||
    hasHolidayPermissions ||
    hasQueuePermissions ||
    hasOmiePermissions;

  if (!hasAnyPermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de Integrações disponível" />
      </div>
    );

  return (
    <>
      {hasBitrixPermissions && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Bitrix
            </Divider>
          </Col>

          <Col span={6}>
            <Form.Item
              label="Webhook"
              name="bitrixWebhookUrl"
              rules={[
                {
                  required: fieldsPermissions?.BitrixWebhookUrl.isRequired,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Input.Password disabled={fieldsPermissions?.BitrixWebhookUrl.access !== 2} />
            </Form.Item>
          </Col>
        </>
      )}

      {hasCnpjPermissions && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              CNPJ
            </Divider>
          </Col>

          {fieldsPermissions?.CnpjApiUrl.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Url"
                name="cnpjApiUrl"
                rules={[
                  {
                    required: fieldsPermissions?.CnpjApiUrl.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input disabled={fieldsPermissions?.CnpjApiUrl.access !== 2} />
              </Form.Item>
            </Col>
          )}

          {fieldsPermissions?.CnpjApiToken.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Token"
                name="cnpjApiToken"
                rules={[
                  {
                    required: fieldsPermissions?.CnpjApiToken.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password disabled={fieldsPermissions?.CnpjApiToken.access !== 2} />
              </Form.Item>
            </Col>
          )}
        </>
      )}

      {hasHolidayPermissions && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Feriados
            </Divider>
          </Col>

          {fieldsPermissions?.HolidayApiUrl.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Url"
                name="holidayApiUrl"
                rules={[
                  {
                    required: fieldsPermissions?.HolidayApiUrl.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input disabled={fieldsPermissions?.HolidayApiUrl.access !== 2} />
              </Form.Item>
            </Col>
          )}

          {fieldsPermissions?.HolidayApiToken.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Token"
                name="holidayApiToken"
                rules={[
                  {
                    required: fieldsPermissions?.HolidayApiToken.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password disabled={fieldsPermissions?.HolidayApiToken.access !== 2} />
              </Form.Item>
            </Col>
          )}
        </>
      )}

      {hasQueuePermissions && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Fila
            </Divider>
          </Col>

          {fieldsPermissions?.Bitrix24QueueMiddlewareEndpoint.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Url"
                name="bitrix24QueueMiddlewareEndpoint"
                rules={[
                  {
                    required: fieldsPermissions?.Bitrix24QueueMiddlewareEndpoint.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input disabled={fieldsPermissions?.Bitrix24QueueMiddlewareEndpoint.access !== 2} />
              </Form.Item>
            </Col>
          )}

          {fieldsPermissions?.Bitrix24QueueMiddlewareAuthToken.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Token"
                name="bitrix24QueueMiddlewareAuthToken"
                rules={[
                  {
                    required: fieldsPermissions?.Bitrix24QueueMiddlewareAuthToken.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password
                  disabled={fieldsPermissions?.Bitrix24QueueMiddlewareAuthToken.access !== 2}
                />
              </Form.Item>
            </Col>
          )}
        </>
      )}

      {hasOmiePermissions && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Omie
            </Divider>
          </Col>

          {fieldsPermissions?.OmieApiUrl.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Url"
                name="omieApiUrl"
                rules={[
                  {
                    required: fieldsPermissions?.OmieApiUrl.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input disabled={fieldsPermissions?.OmieApiUrl.access !== 2} />
              </Form.Item>
            </Col>
          )}

          {fieldsPermissions?.OmieApiKey.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Chave"
                name="omieApiKey"
                rules={[
                  {
                    required: fieldsPermissions?.OmieApiKey.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password disabled={fieldsPermissions?.OmieApiKey.access !== 2} />
              </Form.Item>
            </Col>
          )}

          {fieldsPermissions?.OmieApiSecret.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Segredo"
                name="omieApiSecret"
                rules={[
                  {
                    required: fieldsPermissions?.OmieApiSecret.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password disabled={fieldsPermissions?.OmieApiSecret.access !== 2} />
              </Form.Item>
            </Col>
          )}
        </>
      )}
    </>
  );
}

export default ExternalApisSettings;
